import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/shared/Button';
import { useMassNotifications } from '@/app/contexts/MassNotificationsContext';

export function MassNotificationViewport(): JSX.Element | null {
  const { isSignedIn, isApproved } = useAuth();
  const { notifications, browserPermission, dismissNotification, requestBrowserPermission } = useMassNotifications();

  if (!isSignedIn || !isApproved) {
    return null;
  }

  if (notifications.length === 0 && browserPermission !== 'default') {
    return null;
  }

  return (
    <div className="notification-viewport" aria-live="polite" aria-atomic="false">
      {browserPermission === 'default' ? (
        <div className="notification-card notification-card--permission">
          <div>
            <strong>Enable browser alerts</strong>
            <p>Optional, but helpful for new masses and one-minute CTA warnings.</p>
          </div>
          <Button variant="secondary" onClick={() => void requestBrowserPermission()}>
            Enable Alerts
          </Button>
        </div>
      ) : null}

      {notifications.map((notification) => (
        <article key={notification.id} className="notification-card">
          <div>
            <strong>{notification.title}</strong>
            <p>{notification.message}</p>
          </div>
          <button
            type="button"
            className="notification-card__dismiss"
            onClick={() => dismissNotification(notification.id)}
            aria-label="Dismiss notification"
          >
            x
          </button>
        </article>
      ))}
    </div>
  );
}
